import '@/core/setup/env';
import '@/core/setup/vue';
import '@/core/shared/setup/launchDarkly';
import '@/core/shared/setup/permissions';

import Vue from 'vue';
import router from '@/core/routes';
import store from '@/core/store';
import gql from '@/core/setup/api';
import i18n from '@/core/i18n';
import registerServiceWorker from '@/core/shared/setup/registerServiceWorker';
import { initStore, initGQL, initRouter, initI18n } from '@/core/shared/compositions';
import App from './App';

initStore(store);
initGQL(gql);
initRouter(router);
initI18n(i18n);

registerServiceWorker({
  store,
  i18n,
  projectName: 'Developer Panel',
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render (h) {
    return h(App);
  },
  components: { App },
});
